import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { baseConfig } from './system';
import { semanticTokens } from '../generated/semantic';
import { wrapSemanticRefs, wrapTextStyles } from './utils/to-v3-tokens';

// K12 tenant theme: uses the base spacing / text styles (matches the default
// system) layered on the shared base config.
const k12Config = defineConfig({
  theme: {
    semanticTokens: {
      spacing: wrapSemanticRefs(semanticTokens.space.base, 'spacing'),
    },
    textStyles: wrapTextStyles(semanticTokens.textStyles.base),
  },
});

export const k12 = createSystem(defaultConfig, baseConfig, k12Config);
